import * as React from 'react';
import './ui.css';

/*
 * Input — the one text-input primitive. Styling lives in ui.css (.ui-input),
 * built from the same surface/border/radius tokens as Button/Panel.
 */

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {}

export const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className = '', ...rest }, ref) => {
    const classes = ['ui-input', className].filter(Boolean).join(' ');
    return <input ref={ref} className={classes} {...rest} />;
  },
);

Input.displayName = 'Input';

export default Input;
